import { render } from "./IconElectraPedalAssist.vue?vue&type=template&id=926c7310"
import script from "./IconElectraPedalAssist.vue?vue&type=script&lang=js"
export * from "./IconElectraPedalAssist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__